module.exports = __webpack_public_path__ + "static/image_1_thumb-4c370c1b2587789d8381b6edf99e19ab.jpg";